type Props = {
  onClick?: Function;
};

export default function LogoIconDark({ onClick }: Props) {
  const handleOnClick = () => onClick && onClick();

  return (
    <svg
      width="46"
      height="45"
      viewBox="0 0 46 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`mx-auto h-12 w-auto${onClick && " cursor-pointer"}`}
      onClick={handleOnClick}
    >
      <rect width="45.3263" height="45" rx="22.5" fill="#0D6832" />
      <path
        d="M24.9833 17.2696C23.7222 17.2652 22.4761 17.5454 21.3365 18.0898L21.3303 18.081L21.1901 18.1623C20.8773 18.3201 20.5752 18.4985 20.2856 18.6962V10.5881H16.8795V21.8806C14.534 24.8016 13.2484 28.4418 13.2353 32.1992V32.1992V32.8043H16.3857V32.0929C16.3983 30.5319 16.6839 28.9854 17.2295 27.5244C18.2221 30.7676 21.2559 33.0881 24.9833 33.0881C29.5619 33.0881 33.0882 29.5874 33.0882 25.1764C33.0882 20.7654 29.5619 17.2696 24.9833 17.2696ZM24.9994 29.9887C22.246 29.9887 20.329 27.8895 20.329 25.1814C20.329 22.4733 22.246 20.3728 24.9994 20.3728C27.7217 20.3728 29.6388 22.4733 29.6388 25.1814C29.6388 27.8895 27.7217 29.9887 24.9994 29.9887Z"
        fill="white"
      />
    </svg>
  );
}
